import React from 'react';

export const PepiteLoader = ({ className = "w-16 h-16", fillMode = false }) => {
    return (
        <div className={`relative flex items-center justify-center ${className}`}>
            <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-xl" style={{ overflow: 'visible' }}>
                <defs>
                    <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#fef08a" />
                        <stop offset="50%" stopColor="#f59e0b" />
                        <stop offset="100%" stopColor="#b45309" />
                    </linearGradient>
                    <filter id="glow">
                        <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                        <feMerge>
                            <feMergeNode in="coloredBlur"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                    <style>
                        {`
                            @keyframes drawStar {
                                0% { stroke-dasharray: 0 300; stroke-dashoffset: 0; fill: transparent; transform: rotate(0deg) scale(0.8); }
                                50% { stroke-dasharray: 300 0; stroke-dashoffset: 0; fill: transparent; transform: rotate(180deg) scale(1.1); }
                                100% { stroke-dasharray: 300 0; fill: url(#goldGradient); transform: rotate(360deg) scale(1); }
                            }
                            @keyframes pulseStar {
                                0% { transform: scale(0.95); opacity: 0.8; }
                                100% { transform: scale(1.05); opacity: 1; }
                            }
                            .animate-star-draw {
                                animation: drawStar 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
                                transform-origin: center;
                            }
                            .animate-star-pulse {
                                animation: pulseStar 1.5s ease-in-out infinite alternate;
                                transform-origin: center;
                                fill: url(#goldGradient);
                            }
                        `}
                    </style>
                </defs>
                <path
                    d="M50 5 Q50 50, 95 50 Q50 50, 50 95 Q50 50, 5 50 Q50 50, 50 5 Z"
                    stroke="url(#goldGradient)"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    filter="url(#glow)"
                    className={fillMode ? "animate-star-pulse" : "animate-star-draw"}
                />
            </svg>
        </div>
    );
};
